import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Compact English / हिंदी pill toggle. Drop anywhere — reads current
 * language from i18next directly, so it stays in sync without any
 * Redux / context wiring.
 */
const LanguageToggle: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("hi") ? "hi" : "en";

  const set = (lng: string) => {
    if (lng !== current) void i18n.changeLanguage(lng);
  };

  const btn = (lng: "en" | "hi", label: string) => (
    <button
      onClick={() => set(lng)}
      className={`px-3 py-1 text-xs font-semibold rounded transition ${
        current === lng
          ? "bg-white text-green-700 shadow"
          : "text-white/80 hover:text-white"
      }`}
      aria-pressed={current === lng}
    >
      {label}
    </button>
  );

  return (
    <div className={`inline-flex items-center bg-green-700/40 rounded-md p-0.5 ${className}`}>
      {btn("en", "EN")}
      {btn("hi", "हिं")}
    </div>
  );
};

export default LanguageToggle;
